export default __webpack_public_path__ + "static/nft2-ca8b375c81aab146049f9d0e6d604784.png";